<div class="privacy-container">
  <div class="privacy-content">
    <div class="privacy-header">
      <img src="https://applisound-images.s3.eu-west-3.amazonaws.com/applisound-bleu.png" alt="Applisound logo">
      <h1>{{ 'PRIVACY.TITLE' | translate }}</h1>
      <p class="last-updated">{{ 'PRIVACY.LAST_UPDATED' | translate }}: {{ 'PRIVACY.UPDATE_DATE' | translate }}</p>
    </div>

    <div class="privacy-body">
      <section class="privacy-section">
        <h2>{{ 'PRIVACY.INTRODUCTION.TITLE' | translate }}</h2>
        <p>{{ 'PRIVACY.INTRODUCTION.CONTENT' | translate }}</p>
      </section>

      <section class="privacy-section">
        <h2>{{ 'PRIVACY.DATA_COLLECTED.TITLE' | translate }}</h2>
        <p>{{ 'PRIVACY.DATA_COLLECTED.CONTENT' | translate }}</p>
        <h3>{{ 'PRIVACY.DATA_COLLECTED.PERSONAL_DATA.TITLE' | translate }}</h3>
        <ul>
          <li>{{ 'PRIVACY.DATA_COLLECTED.PERSONAL_DATA.ITEM1' | translate }}</li>
          <li>{{ 'PRIVACY.DATA_COLLECTED.PERSONAL_DATA.ITEM2' | translate }}</li>
          <li>{{ 'PRIVACY.DATA_COLLECTED.PERSONAL_DATA.ITEM3' | translate }}</li>
          <li>{{ 'PRIVACY.DATA_COLLECTED.PERSONAL_DATA.ITEM4' | translate }}</li>
        </ul>
        <h3>{{ 'PRIVACY.DATA_COLLECTED.TECHNICAL_DATA.TITLE' | translate }}</h3>
        <ul>
          <li>{{ 'PRIVACY.DATA_COLLECTED.TECHNICAL_DATA.ITEM1' | translate }}</li>
          <li>{{ 'PRIVACY.DATA_COLLECTED.TECHNICAL_DATA.ITEM2' | translate }}</li>
          <li>{{ 'PRIVACY.DATA_COLLECTED.TECHNICAL_DATA.ITEM3' | translate }}</li>
        </ul>
      </section>

      <section class="privacy-section">
        <h2>{{ 'PRIVACY.DATA_USAGE.TITLE' | translate }}</h2>
        <p>{{ 'PRIVACY.DATA_USAGE.CONTENT' | translate }}</p>
        <ul>
          <li>{{ 'PRIVACY.DATA_USAGE.ITEM1' | translate }}</li>
          <li>{{ 'PRIVACY.DATA_USAGE.ITEM2' | translate }}</li>
          <li>{{ 'PRIVACY.DATA_USAGE.ITEM3' | translate }}</li>
          <li>{{ 'PRIVACY.DATA_USAGE.ITEM4' | translate }}</li>
          <li>{{ 'PRIVACY.DATA_USAGE.ITEM5' | translate }}</li>
        </ul>
      </section>

      <section class="privacy-section">
        <h2>{{ 'PRIVACY.DATA_SHARING.TITLE' | translate }}</h2>
        <p>{{ 'PRIVACY.DATA_SHARING.CONTENT' | translate }}</p>
        <ul>
          <li>{{ 'PRIVACY.DATA_SHARING.ITEM1' | translate }}</li>
          <li>{{ 'PRIVACY.DATA_SHARING.ITEM2' | translate }}</li>
          <li>{{ 'PRIVACY.DATA_SHARING.ITEM3' | translate }}</li>
        </ul>
      </section>

      <section class="privacy-section">
        <h2>{{ 'PRIVACY.DATA_SECURITY.TITLE' | translate }}</h2>
        <p>{{ 'PRIVACY.DATA_SECURITY.CONTENT1' | translate }}</p>
        <p>{{ 'PRIVACY.DATA_SECURITY.CONTENT2' | translate }}</p>
      </section>

      <section class="privacy-section">
        <h2>{{ 'PRIVACY.USER_RIGHTS.TITLE' | translate }}</h2>
        <p>{{ 'PRIVACY.USER_RIGHTS.CONTENT' | translate }}</p>
        <ul>
          <li>{{ 'PRIVACY.USER_RIGHTS.ITEM1' | translate }}</li>
          <li>{{ 'PRIVACY.USER_RIGHTS.ITEM2' | translate }}</li>
          <li>{{ 'PRIVACY.USER_RIGHTS.ITEM3' | translate }}</li>
          <li>{{ 'PRIVACY.USER_RIGHTS.ITEM4' | translate }}</li>
          <li>{{ 'PRIVACY.USER_RIGHTS.ITEM5' | translate }}</li>
          <li>{{ 'PRIVACY.USER_RIGHTS.ITEM6' | translate }}</li>
        </ul>
      </section>

      <section class="privacy-section">
        <h2>{{ 'PRIVACY.COOKIES.TITLE' | translate }}</h2>
        <p>{{ 'PRIVACY.COOKIES.CONTENT1' | translate }}</p>
        <p>{{ 'PRIVACY.COOKIES.CONTENT2' | translate }}</p>
        <h3>{{ 'PRIVACY.COOKIES.TYPES.TITLE' | translate }}</h3>
        <ul>
          <li><strong>{{ 'PRIVACY.COOKIES.TYPES.ESSENTIAL.TITLE' | translate }}</strong>: {{ 'PRIVACY.COOKIES.TYPES.ESSENTIAL.DESC' | translate }}</li>
          <li><strong>{{ 'PRIVACY.COOKIES.TYPES.ANALYTICS.TITLE' | translate }}</strong>: {{ 'PRIVACY.COOKIES.TYPES.ANALYTICS.DESC' | translate }}</li>
          <li><strong>{{ 'PRIVACY.COOKIES.TYPES.MARKETING.TITLE' | translate }}</strong>: {{ 'PRIVACY.COOKIES.TYPES.MARKETING.DESC' | translate }}</li>
        </ul>
      </section>

      <section class="privacy-section">
        <h2>{{ 'PRIVACY.DATA_RETENTION.TITLE' | translate }}</h2>
        <p>{{ 'PRIVACY.DATA_RETENTION.CONTENT' | translate }}</p>
      </section>

      <section class="privacy-section">
        <h2>{{ 'PRIVACY.INTERNATIONAL_TRANSFERS.TITLE' | translate }}</h2>
        <p>{{ 'PRIVACY.INTERNATIONAL_TRANSFERS.CONTENT' | translate }}</p>
      </section>

      <section class="privacy-section">
        <h2>{{ 'PRIVACY.POLICY_CHANGES.TITLE' | translate }}</h2>
        <p>{{ 'PRIVACY.POLICY_CHANGES.CONTENT' | translate }}</p>
      </section>

      <section class="privacy-section">
        <h2>{{ 'PRIVACY.CONTACT.TITLE' | translate }}</h2>
        <p>{{ 'PRIVACY.CONTACT.CONTENT' | translate }}</p>
        <div class="contact-info">
          <p><strong>{{ 'PRIVACY.CONTACT.COMPANY' | translate }}</strong></p>
          <p>{{ 'PRIVACY.CONTACT.EMAIL' | translate }}: <a href="mailto:privacy@applisound.com">privacy&#64;applisound.com</a></p>
          <p>{{ 'PRIVACY.CONTACT.PHONE' | translate }}: +33 6 28 79 41 00</p>
        </div>
      </section>
    </div>
  </div>
</div>